"use client";

import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router";
import { GiCargoCrate } from "react-icons/gi";

export default function EmptyStateMyLoads({
  bgColor = "bg-blue-50",
  bgColor1 = "bg-blue-50",
  bgColor2 = "bg-blue-50",
  icon = GiCargoCrate,

  colorContent = "text-special",
  title = "باری برای نمایش وجود ندارد",
  subtitle = "هنوز بار ثبت نکرده‌اید.",
  ctaText = "افزودن بار جدید",
  onCta = null,
  bottomColorClass = "bg-special border-special",
  ShowButton = true
}) {
  const navigate = useNavigate();

  const Icon = icon;

  const floatVariants = {
    animate: {
      y: [0, -8, 0],
      transition: { duration: 2.4, repeat: Infinity, ease: "easeInOut" },
    },
  };

  const pop = {
    hidden: { opacity: 0, scale: 0.98, y: 6 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.45 } },
  };

  return (
    <div className="w-full flex items-center justify-center py-12 px-4">
      <motion.div
        className={`relative max-w-2xl w-full bg-opacity-80 ${bgColor} rounded-2xl shadow-lg p-8 flex flex-col items-center text-center overflow-hidden`}
        variants={pop}
        initial="hidden"
        animate="visible"
      >
        <motion.div
          aria-hidden
          className={`absolute -left-20 -top-16 w-64 h-64 rounded-full blur-3xl opacity-30 ${bgColor1}`}
          animate={{ rotate: [0, 10, 0] }}
          transition={{ duration: 8, repeat: Infinity }}
        />
        <motion.div
          aria-hidden
          className={`absolute -right-20 -bottom-16 w-64 h-64 rounded-full blur-3xl opacity-20 ${bgColor2}`}
          animate={{ rotate: [0, -8, 0] }}
          transition={{ duration: 9, repeat: Infinity }}
        />

        <motion.div className="mb-6 z-10" variants={floatVariants} animate="animate">
          {Icon ? (
            <Icon className={`w-16 h-16 ${colorContent} inline-block`} aria-hidden />
          ) : null}
        </motion.div>

        <div className="z-10">
          <h3 className={`text-xl sm:text-2xl font-semibold ${colorContent} `}>
            {title}
          </h3>
          <p className={`mt-2 text-gray-500  max-w-[28rem] ${colorContent} leading-7`}>
            {subtitle}
          </p>

          <div className="mt-6 flex flex-col sm:flex-row gap-3 items-center justify-center">
            {ShowButton && (
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onCta && onCta()}
                className={`${bottomColorClass} text-white px-4 py-2 rounded-lg text-sm sm:text-base font-medium shadow-sm hover:brightness-95 transition-all`}
              >
                {ctaText}
              </motion.button>
            )}
          </div>
        </div>


      </motion.div>
    </div>
  );
}
